import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime, distinctUntilChanged, from, lastValueFrom, Observable, OperatorFunction, map } from 'rxjs';
import { Utilities } from 'src/app/models/utilities';
import { pincodePattern, PincodeValidation } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddODAComponent {
  addForm: FormGroup;
  @Input() showSlabsModal = false;
  @Input() mappingId: number;

  isFormSubmitted = false;

  Id: number;
  typeList: any[] = [{ name: 'Customer' }, { name: 'Vendor' }, { name: 'Tariff' }]
  serviceList: any[];
  countryList: any[];
  stateList: any[];
  cityList: any[];
  pincodeList: any[];
  vendorList: any[];
  customerList: any[];
  countryCode: string;
  chargeType: any;
  CustomerType: boolean
  chargesList: any[];
  isActionAllowed = true;
  minPincode
  maxPincode
  editMode = false;
  detailId: any;

  // useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoaderService: NgxUiLoaderService,
    private chargesService: ChargesService,
    private vendorService: VendorService,
    private geoService: GeoService,
    private customerService: CustomerService,
    private appCoreService: AppCoreService,
    public activeModal: NgbActiveModal,
    public utilities: Utilities,
  ) { }

  ngOnInit(): void {
    this.CustomerType = true
    this.Id = this.route.snapshot.params['id']
    this.addForm = this.formBuilder.group({
      txtPincode: [null],
      ddlType: [null, Validators.required],
      ddlCustomer: [null, Validators.required],
      ddlVendor: [null, Validators.required],
      ddlService: [null],
      txtODASwitch: [false],
      txtServiceableSwitch: [false],
      ddlCountry: [null, Validators.required],
      ddlState: [null],
      ddlCity: [null]
    });
    this.bindPincodes();
    this.bindCountries();
    this.getAllCustomers();
    this.getAllVendors();
    if (this.mappingId) {
      this.getById(this.mappingId);
      this.editMode = true;
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.title === 'Charges Master Management');
    if (permission.length) {
      this.isActionAllowed = permission[0].config.delete;
    } else {
      this.isActionAllowed = false;
    }
  }

  setPincodeValidation() {
    if (this.addForm) {
      const pincodeControl = this.addForm.get('txtPincode');

      if (typeof pincodeControl?.value === 'string') {
        // Find the country code based on isocode
        const matchedCountryCode = this.countryList.find(x => x.isocode === this.countryCode)?.code;
        if (matchedCountryCode && pincodePattern[matchedCountryCode]) {
          // Get the pattern for the selected country
          const pattern = pincodePattern[matchedCountryCode];
          // console.log(this.locationDetailsForm.get('txtPincode').errors);

          this.minPincode = 0
          this.maxPincode = 0
          this.minPincode = this.utilities.getMinLength(pattern)
          this.maxPincode = this.utilities.getMaxLength(pattern)

          // Set the validators for the pincode field
          pincodeControl.setValidators([
            Validators.pattern(pattern),
            Validators.minLength(this.minPincode),
            Validators.maxLength(this.maxPincode)
          ]);
        } else {
          pincodeControl.setValidators([PincodeValidation]);
        }
        pincodeControl.updateValueAndValidity();
      }
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) return true; else return false;
  }

  pincodeFormatter = (x: { pincode: string }) => x.pincode;

  async getById(id: number) {
    // console.log("getbyid")
    try {
      if (id) {
        this.ngxLoaderService.start();
        const res = await lastValueFrom(this.chargesService.GetODAById(id));
        if (res && res.success) {
          this.Id = id;
          this.editMode = true;
          const data = res.data[0];
          // this.addForm.get('ddlType').setValue(
          //     data?.customerid ? this.typeList[0].name 
          //     : data?.vendorid ? this.typeList[1].name
          //     : this.typeList[2].name
          // );
          this.onChangeChargeType();
          this.addForm.patchValue({
            txtPincode: (typeof data.pincode === 'string') ? { pincode: data.pincode } : data.pincode,
            ddlCustomer: data?.customerid,
            ddlVendor: data?.vendorid,
            ddlType: data?.type,
            txtODASwitch: data?.isoda,
            txtServiceableSwitch: data.isserviceable,
          });

          const type = this.addForm.get('ddlType').value;
          // console.log('type',type);
          if (type == "Vendor" || type == "Tariff") {
            this.CustomerType = false;
          } else {
            this.CustomerType = true;
          }
          await lastValueFrom(from(this.bindService()));
          this.serviceList.find(x => x.id == data.serviceid)
            ? this.addForm.get('ddlService').setValue(data.serviceid)
            : null;
          this.addForm.get('ddlCountry').setValue(data.countryisocode);
          await lastValueFrom(from(this.bindStatesByCountry(data.countryisocode)));
          await lastValueFrom(from(this.bindCitiesByState(data.stateisocode)));
          this.addForm.get('ddlState').setValue(data.stateisocode);
          this.addForm.get('ddlCity').setValue(data.cityisocode);
        }
      }
    } catch (error) {
    } finally {
      this.ngxLoaderService.stop();
    }
  }

  upsert() {
    try {
      this.isFormSubmitted = true;
      if (this.addForm.valid) {
        const picodeObj = this.addForm.get('txtPincode').value;
        const reqObj = {
          id: this.Id || null,
          type: this.addForm.get('ddlType').value,
          pincode: (typeof picodeObj === 'string') ? picodeObj : picodeObj?.pincode,
          customerid: this.addForm.get('ddlCustomer').value,
          vendorid: this.addForm.get('ddlVendor').value,
          serviceid: this.addForm.get('ddlService').value,
          countryisocode: this.addForm.get('ddlCountry').value,
          stateisocode: this.addForm.get('ddlState').value,
          cityisocode: this.addForm.get('ddlCity').value,
          isODA: this.addForm.get('txtODASwitch').value,
          isServiceable: this.addForm.get('txtServiceableSwitch').value,
        };
        // console.log("reqobj", reqObj);
        this.ngxLoaderService.start();
        const apiCall = this.editMode
          ? this.chargesService.UpdateODA(reqObj)
          : this.chargesService.AddODA(reqObj);

        apiCall.subscribe((res) => {
          // console.log("res",res);
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.activeModal.close('Save click');
            this.appCoreService.showMessage(this.editMode ? "Record Updated Successfully" : "Record Added Successfully");
            this.resetForm();
          } else if (res && res.success == false) {
            // console.log(res);
            this.ngxLoaderService.stop();
            const msg = res.message;
            this.errDialog(msg);
          }
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.ngxLoaderService.stop();
    }
  }

  async errDialog(msg: any) {
    await Swal.fire({
      title: 'Opps!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }
  searchPincode: OperatorFunction<string, readonly { pincode; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.pincodeList.filter((v) => v.pincode.toLowerCase().startsWith(term.toLowerCase())).slice(0, 10),
      ),
    );

  async onPincodeChanged() {
    try {
      const pinObj = this.addForm.get('txtPincode').value;
      if (typeof pinObj == 'string') {
        this.addForm.get('txtPincode').setValidators([PincodeValidation]);
      } else {
        this.addForm.get('txtPincode').clearValidators();
      }
      this.addForm.get('txtPincode').updateValueAndValidity();
      if (typeof pinObj != 'string') {
        this.addForm.get('ddlCountry').setValue(pinObj.countryisocode);
        await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
        await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
        this.addForm.get('ddlState').setValue(pinObj.stateisocode);
        this.addForm.get('ddlCity').setValue(pinObj.cityisocode);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async bindStatesByCountry(countryCode?: string): Promise<void> {
    try {
      if (countryCode) {
        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.stateList = res.data;
          this.countryCode = countryCode;
        } else {
          throw new Error('Error fetching data');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async bindCitiesByState(stateCode?: string): Promise<void> {
    try {
      if (stateCode) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.cityList = res.data;
        } else {
          throw new Error('Error fetching data');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          this.countryList = res.data;
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  onCountryChange() {
    const selectedValue = this.addForm.get('ddlCountry').value;
    if (selectedValue) {
      this.bindStatesByCountry(selectedValue);
      this.stateList = []; this.cityList = [];
      this.addForm.get('ddlState').reset();
      this.addForm.get('ddlCity').reset();
    }
  }

  onStateChange() {
    const selectedValue = this.addForm.get('ddlState').value;
    if (selectedValue) {
      this.bindCitiesByState(selectedValue);
      this.cityList = [];
      this.addForm.get('ddlCity').reset();
    }
  }

  bindPincodes() {
    this.geoService.GetAllPincodes().subscribe((res) => {
      if (res && res.success) {
        this.pincodeList = res.data;
      }
    });
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter, isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.customerList = res.data;
        }
      })
    } catch (error) {
    }
  }

  async getAllVendors() {
    const res = await lastValueFrom(this.vendorService.GetAll({ isactive: true }));
    res?.success ? this.vendorList = res.data : [];
  }

  async bindService() {
    const id = this.addForm.get('ddlVendor').value;
    this.addForm.get('ddlService').reset();
    const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id: id }));
    this.serviceList = res?.success ? res.data : null;
  }

  onChangeChargeType() {
    this.isFormSubmitted = false;
    this.addForm.get('ddlCustomer').reset();
    this.addForm.get('ddlVendor').reset();
    this.addForm.get('ddlService').reset();
    this.chargeType = this.addForm.get('ddlType').value;
    const vendor = this.addForm.get('ddlVendor').value;
    vendor ? this.addForm.get('ddlCustomer').disable() : this.addForm.get('ddlCustomer').enable();
    if (this.chargeType == 'Vendor') {
      this.addForm.get('ddlCustomer').setValue(null);
      this.addForm.get('ddlCustomer').disable();
      this.addForm.get('ddlCustomer').clearValidators();
      this.addForm.get('ddlVendor').setValidators([Validators.required]);
      this.CustomerType = false;
    } else if (this.chargeType == 'Tariff') {
      this.addForm.get('ddlCustomer').setValue(null);
      this.addForm.get('ddlCustomer').disable();
      this.addForm.get('ddlCustomer').clearValidators();
      this.addForm.get('ddlVendor').clearValidators();
      this.CustomerType = false;
    }
    else {
      this.addForm.get('ddlCustomer').enable();
      this.addForm.get('ddlVendor').clearValidators();
      this.addForm.get('ddlCustomer').setValidators([Validators.required]);
      this.CustomerType = true;
    }
    this.addForm.get('ddlCustomer').updateValueAndValidity();
    this.addForm.get('ddlVendor').updateValueAndValidity();
  }

  blockFormSubmit() {
    return false;
  }

  resetForm() {
    this.isFormSubmitted = false;
    this.editMode = false;
    this.addForm.reset();
    this.Id = null;
  }

}
